import React from 'react'
import { Row, Col, Button } from 'react-bootstrap'
import SpinnerContainer from '../../common/spinner-container'

const MessagesListPaginated = ({
    isLoading,
    hasMore,
    messages = [],
    onLoadMore = () => {},
    messageComponent
}) => {
    const renderMessage = (message, key) => {
        const MessageComponent = messageComponent
        return (
            <MessageComponent
                key={key}
                message={message}
            />
        )
    }
    return (
        <React.Fragment>
            
            <Row style={{ paddingTop: '20px'}}>
                <Col>
                    {messages.map(renderMessage)}
                    {messages.length===0 && !isLoading && <Col className='text-muted text-center'>There are no messages.</Col>}
                </Col>
            </Row>
            {isLoading && <Row><Col className='text-center'><SpinnerContainer /></Col></Row>}
            <Row style={{ paddingTop: '20px'}}>
                <Col xs={{ span: 10, offset: 1 }}>
                    <Button onClick={() => onLoadMore()} disabled={isLoading || !hasMore} block>Load More</Button>
                </Col>
            </Row>
        </React.Fragment>
    )
}

export default MessagesListPaginated